var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ns-asko"}},[(_vm.initLoad)?_c('loading-block'):_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c(_vm.store.currentRoute,_vm._b({tag:"component"},'component',_vm.store,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }